import { Injectable, WritableSignal, computed, signal } from "@angular/core";
import { toObservable, takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { filter, switchMap, timer, tap } from "rxjs";

export type MessageType = "success" | "info" | "error" | "warning";

export interface Message {
  type: MessageType;
  isVisible: boolean;
  text: string | string[];
  traceId?: string;
}

@Injectable({
  providedIn: "root",
})
export class MessageService {
  readonly messageDelay = 5000;
  private message: WritableSignal<Message> = signal({
    type: "success",
    isVisible: false,
    text: "",
  });

  type = computed(() => this.message().type);
  text = computed(() => this.message().text);
  traceId = computed(() => this.message().traceId);
  isVisible = computed(() => this.message().isVisible);

  show(type: MessageType, text: string | string[], traceId?: string) {
    this.message.set({
      type,
      text,
      isVisible: true,
      traceId
    });
  }

  hide() {
    this.message.update((message) => {
      return { ...message, isVisible: false };
    });
  }

  constructor() {
    // hide message after delay
    toObservable(this.message)
      .pipe(
        takeUntilDestroyed(),
        filter((message) => message.isVisible ),
        switchMap(() => timer(this.messageDelay)),
        tap(() => this.hide())
      )
      .subscribe();
  }
}
